const ExperienceItem = ({ entry }) => {
  const { company, role, period, summary, highlights, links, featured } = entry;
  return (
    <article className={`timeline-item${featured ? ' featured' : ''}`}>
      <div className="timeline-when">
        <h4>{period}</h4>
      </div>
      <div className="timeline-what">
        <h3>{company}</h3>
        <h4>{role}</h4>
        <p>{summary}</p>
        {highlights && (
          <ul className="timeline-highlights">
            {highlights.map((item) => <li key={item}>{item}</li>)}
          </ul>
        )}
        {links && (
          <ul className="timeline-links">
            {links.map((link) => (
              <li key={link.href}><a href={link.href} target="_blank" rel="noopener noreferrer">{link.label}</a></li>
            ))}
          </ul>
        )}
      </div>
    </article>
  );
}

export default ExperienceItem;
